import {Component, Input, ViewChild} from "@angular/core";
import {EditGridComponent} from "../../../framework/entity/edit/edit-grid/edit-grid.component";
import {EntityData, field, identifier, ReportModel} from "@fedeltapointofsale/data-client";
import {ProductBarcodeSearchPageComponent} from "../product-barcode-search-page/product-barcode-search-page.component";

export class ProductBarcodeReportSelectionData extends EntityData<ProductBarcodeReportSelectionData> {
    @identifier productBarcodeId: number;
    @field sellableId: number;
    @field name: string;
    @field barcode: string;
    @field price: number;
    @field qty: number = 1;
}

@Component({
    selector: "wbo-product-barcode-report-selection",
    templateUrl: "./product-barcode-report-selection-control.component.html"
})
export class ProductBarcodeReportSelectionControlComponent {

    ProductBarcodeSearchPageComponent = ProductBarcodeSearchPageComponent;

    fieldName: string = "barcodes";

    /**
     * Indicates of the quantity column should be shown
     */
    @Input() editQty: boolean;

    @ViewChild(EditGridComponent) editGridComponent: EditGridComponent;

    constructor(public model: ReportModel<any>) {
    }

    addFromProduct(data: any[]): void {
        data.forEach((item) => {
            if (!this.model.data[this.fieldName].find((inventory: any) => inventory.productBarcodeId === item.productBarcodeId)) {
                const index: number = this.editGridComponent.addRow(item) - 1;
            }
        });
    }
}
